import React from 'react';
import './InfoScreen.css';

export default function InfoScreen({ logotema, texto, imagen_info, onBack }) {
  return (
    <div className="info-container">
      <button className="info-back" onClick={onBack}>← Volver</button>
      <div className="info-logotema-box">
        {logotema ? (
          <img src={logotema} alt="Logotema tratamiento" className="info-logotema" style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px #0002', objectFit: 'contain', padding: 4 }} />
        ) : (
          <img src="/logo192.png" alt="Braineka logo" className="info-logotema" />
        )}
      </div>
      <div className="info-texto">
        {/* Texto superior (opcional) */}
        {Array.isArray(texto) ? texto[0] : texto}
        {/* Imagen info en el centro si existe */}
        {imagen_info && (
          <div className="info-imagen-info-box">
            <img src={imagen_info} alt="Imagen info" className="info-imagen-info" />
          </div>
        )}
        {/* Texto inferior si texto es array */}
        {Array.isArray(texto) && texto[1] && (
          <div className="info-texto-secundario">{texto[1]}</div>
        )}
      </div>
    </div>
  );
}
